<template>
    <div class="column-option co-input">
        <input type="text" v-model="valueExt">
    </div>
</template>

<script>
export default {
    name: "input-option",
    props: ['option', 'index', 'value'],
    model: {
        prop: 'value',
        event: 'valuechange'
    },
    data(){
        return {

        }
    },
    computed: {
        valueExt: {
            get: function () {
                if(typeof this.value === 'undefined') return importApp.getDefaultOptionValue(this.option);
                if(typeof this.value[this.option] === 'undefined') return importApp.getDefaultOptionValue(this.option);
                if(Array.isArray(this.value)) return importApp.getDefaultOptionValue(this.option);

                return this.value[this.option];

            },
            set: function (value) {
                let val = this.value;
                val[this.option] = value;

                this.$emit('valuechange', val);
                this.$emit('change', val, this.index);

            }
        }
    }
}
</script>

<style scoped>

</style>
